
import Vue, { PropType } from "vue";
import { DialogI, DialogCloseType } from "@/types/dialog";
import { ProductionPromptStepPayload } from "@/utils/productionPromptService";
import ProductionPromptStep from "@/components/trainer/ProductionPromptStep.vue";

// Thin modal shell around ProductionPromptStep — the step owns all orchestration so it can
// also be rendered inline (LessonWordsTrainer). This wrapper just provides the dialog chrome.
export default Vue.extend({
  name: "ProductionPromptDialog",
  components: { ProductionPromptStep },
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
  computed: {
    payload(): ProductionPromptStepPayload {
      return (this.dialog.config?.payload || {}) as ProductionPromptStepPayload;
    },
  },
  methods: {
    closeDialog(): void {
      this.dialog.close({ type: DialogCloseType.SUBMITTED, payload: {} });
    },
    // Route the topbar X through the step so SKIPPED is recorded before the dialog closes
    // (the step owns the one-terminal-event rule); the step then emits `done` -> closeDialog.
    onTopbarClose(): void {
      const step = this.$refs.step as InstanceType<typeof ProductionPromptStep> | undefined;
      if (step) {
        step.onClose();
      } else {
        this.closeDialog();
      }
    },
  },
});
